<template>
    <div>
        <div  :style="{height: tableHeight+'px',minWidth: '300px',overflowY: 'auto'}">

            <el-tree ref="tree" :data="treeData" lazy :key="treeId" :load="loadNode" :props="defaultProps"
                     node-key="i_id" @node-click="handleNodeClick" :default-expanded-keys="[0]"
                     class="trees  video-tree height100" accordion :highlight-current='true'
                     :expand-on-click-node="false" :show-checkbox="false">
            </el-tree>

        </div>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <el-button type="primary" @click="saveForm" :class="baseerp+'btn'" size="mini"  :disabled="disabled" >{{$t('button_confirm')}}</el-button>
            <el-button @click="cancel" size="mini">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";

    export default {
        name: "TransferArea",
        components: {},
        props:{
            data:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                defaultProps: {
                    children: 'children',
                    label: 'label',
                    isLeaf: 'isLeaf',
                    value:'i_id'
                },
                treeData:[{i_id:0,i_level:1,i_pid:0,label:'全部',children:[],isLeaf:false}],
                treeId:0,
                baseerp:'',
                chooseNode:null,
                tableHeight:0,
                disabled:false,
        }
        },
        watch:{
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.$nextTick(()=>{
                this.onResize();
            })
            console.log('TransferArea',this.data)
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-(n.h)*0.3;
                if(this.tableHeight<60)this.tableHeight=60;
            },
            handleNodeClick(val){
                this.chooseNode=val
            },
            cancel(){
                this.$emit('close',null)
            },
            saveForm(){
                if(this.chooseNode.i_level!=this.data.i_level-1){
                    this.$message.warning('只能移动到原父级别的同级下');
                    return
                }
                this.editArea();
                this.disabled=true;
            },
            loadNode(node, resolve) {
                let _this=this;
                if (node.level === 0) {
                    let val={i_id:0,i_level:0,i_pid:0,label:'全部',vc_name:'全部',children:[],childProduct:0,isLeaf:false};
                    return resolve([val]);
                }
                if (node.level>=1&&node.data.isLeaf==false){
                    _this.getAreaTree(node.data,resolve,node.level);
                }
            },
            async getAreaTree({i_id=0},resolve,level){
                let param = {
                    i_pid:i_id,
                    isuse:1,
                };
                let res = await API.getAreaTree(param);
                if (res.code == 1) {
                    let list=[];
                    if (res.data.length>0){
                        res.data.map(one=>{
                            let hash=one;
                            hash.isLeaf= one.i_level<3?!one.hassub:true;
                            hash.i_level= one.i_level;
                            hash.label= one.vc_name;

                            //     {
                            //     label:one.vc_name,
                            //     i_id:one.i_id,
                            //     type:one.type,
                            //     i_level:level+1,
                            //     // i_pid:one.i_pid,
                            //     isLeaf: one.childProduct==0,
                            // };
                            list.push(hash);
                        })
                    }
                    return resolve(list);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async editArea(){
                // this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
                // this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
                // this.formData.i_lruid=sessionStorage.getItem("userid");//renid
                let param={
                    "i_id":this.data.i_id,
                    "vc_name":this.data.vc_name,
                    "vc_ename":this.data.vc_ename,
                    "vc_sname":this.data.vc_sname,
                    "i_pid":this.chooseNode.i_id,
                    "i_level":this.data.i_level,
                    "isuse":1
                };
                let res=await API.editArea(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.canEdit=false
                    this.$emit('close','save')
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.canEdit=false
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    /deep/ {
        .el-tree-node__label {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .el-tree-node__content{
            width: 100%;
        }
    }
    .menu{
        /*display: flex;*/
        border: 1px solid #8e8e8e;
        right: 0;
        position: absolute;
        background-color: #fff;
        box-shadow:0 2px 8px rgba(0,0,0,0.1);
    }
    .info{
        /*border: 1px solid #8e8e8e;*/
        padding: 5px 15px;
    }
    .info:hover{
        background-color: #CCCCCC;

    }

</style>